module.exports = __webpack_public_path__ + "static/media/andrew_huynh.ba051ecf.png";